export default function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/date-fns/esm/_lib/requiredArgs/index.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8